export default __webpack_public_path__ + "static/media/hillKnowltonLogo.4d28fea6.png";